export default angular
  .module("ScriptSummaryCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ScriptSummaryController", [
    "$scope",
    "$timeout",
    "$location",
    "$state",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "Message",
    "System",
    "ScriptLoading",
    "modal",
    function (
      $scope,
      $timeout,
      $location,
      $state,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      Message,
      System,
      ScriptLoading,
      modal,
    ) {
      $scope.openSummaryTranslationModal = function (SUMMARY_FIELD) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/editMessageTranslation.html",
          backdrop: "static",
          controller: "ModifySummaryTranslationController",
          resolve: {
            summaryData() {
              return {
                SCRIPT_ID: $scope.scriptmeta.ID,
                SUMMARY_FIELD,
              };
            },
          },
        });
        modalInstance.result.then(() => {
          Scripts.loadScriptSummaryByID($scope.scriptmeta.ID, "en", (
            data,
            status,
          ) => {
            $scope.scriptsummary = data;
            $scope.scriptsummary.SCRIPT_ID = $scope.scriptmeta.ID;
            if (status === 200) {
              ScriptLoading.markSummaryRisksResourceLoaded("summaryEN");
            }
          });
          Scripts.loadScriptSummaryByID(
            $scope.scriptmeta.ID,
            $rootScope.loggedUser.language,
            (data, status) => {
              $scope.scriptsummarylang = data;
              if (status === 200) {
                ScriptLoading.markSummaryRisksResourceLoaded("summaryUserLang");
              }
            },
          );
        });
      };

      // User clicked add risk button.
      $scope.addRisk = function () {
        const newrisk = {};
        newrisk.SCRIPT_ID = $scope.scriptmeta.ID;
        newrisk.TEXT = "";
        Scripts.updateScriptRisk(newrisk, () => {
          Scripts.loadScriptRiskByID($scope.scriptmeta.ID, (
            data,
            status,
          ) => {
            $scope.scriptrisk = data;
            if ($scope.scriptrisk) {
              $scope.riskExist = true;
            }
            if (status === 200) {
              ScriptLoading.markSummaryRisksResourceLoaded("risk");
            }
          });
        });
      };

      // open modal to delete risk
      $scope.openDeleteRiskModal = function (risk) {
        modal.openDelete(risk.TEXT, "Risk").result.then(() => {
          Scripts.deleteScriptRisk(risk, () => {
            Scripts.loadScriptRiskByID($scope.scriptmeta.ID, (
              data,
              status,
            ) => {
              $scope.scriptrisk = data;
              if ($scope.scriptrisk) {
                $scope.riskExist = true;
              }
              if (status === 200) {
                ScriptLoading.markSummaryRisksResourceLoaded("risk");
              }
            });
          });
        });
      };
      // Save changes to script. User clicked save changes -button in left menu
      // after modifying script.
      const scriptListener = $rootScope.$on("saveScriptChanges", () => {
        if ($rootScope.changedFields.get("summary")) {
          $scope.scriptsummary.LANG = "en";
          Scripts.updateScriptSummary(
            $scope.scriptsummary,
            $scope.scriptmeta.ID,
            () => {
              Scripts.markSaved("summary");
            },
          );
        }
        if ($rootScope.changedFields.get("summarylang")) {
          $scope.scriptsummarylang.LANG = $rootScope.loggedUser.language;
          Scripts.updateScriptSummary(
            $scope.scriptsummarylang,
            $scope.scriptmeta.ID,
            () => {
              Scripts.markSaved("summarylang");
            },
          );
        }
        if ($rootScope.changedFields.get("risk")) {
          for (let i = 0; $scope.scriptrisk.length > i; i++) {
            Scripts.updateScriptRisk($scope.scriptrisk[i], () => {
              Scripts.markSaved("risk");
            });
          }
        }
        if ($rootScope.changedFields.get("newrisk")) {
          const newscript = {};
          newscript.SCRIPT_ID = $scope.scriptmeta.ID;
          newscript.TEXT = $scope.newrisk.VALUE;
          Scripts.updateScriptRisk(newscript, () => {
            Scripts.markSaved("newrisk");
          });
        }
      });
      $scope.$on("$destroy", scriptListener);
    },
  ]);
